import React from "react";
import { CheckOutlined, MinusOutlined } from "@ant-design/icons";
import { getParentToggleState } from "./constants";

function ModuleToggle({ mod, checked, indeterminate = false, onToggle, variant = "default" }) {
  const isChild = variant === "child";

  return (
    <button
      type="button"
      className={[
        "mu-invite__module",
        isChild ? "mu-invite__module--child" : "",
        checked ? "mu-invite__module--checked" : "",
        indeterminate ? "mu-invite__module--indeterminate" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={() => onToggle(mod.key)}
      aria-pressed={checked || indeterminate}
    >
      <span className="mu-invite__module-check">
        {checked ? <CheckOutlined /> : indeterminate ? <MinusOutlined /> : null}
      </span>
      {!isChild ? <i className={`ki-outline ${mod.icon}`} aria-hidden /> : null}
      <span className="mu-invite__module-label">{mod.label}</span>
    </button>
  );
}

function ModuleGroup({ page, selectedModules, assignableKeys, onToggleModule }) {
  const children = page.children || [];
  const selectedChildCount = children.filter((child) =>
    selectedModules.includes(child.key)
  ).length;
  const parentState = getParentToggleState(page, selectedModules, assignableKeys);

  return (
    <div
      className={[
        "mu-invite__module-group",
        parentState.checked || selectedChildCount > 0 ? "mu-invite__module-group--active" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="mu-invite__module-group-head">
        <ModuleToggle
          mod={page}
          checked={parentState.checked}
          indeterminate={parentState.indeterminate}
          onToggle={onToggleModule}
          variant="parent"
        />
      </div>

      {children.length > 0 ? (
        <div className="mu-invite__module-children">
          {children.map((child, index) => (
            <div
              key={child.key}
              className={[
                "mu-invite__module-child-row",
                index === children.length - 1 ? "mu-invite__module-child-row--last" : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <span className="mu-invite__module-child-connector" aria-hidden />
              <ModuleToggle
                mod={child}
                checked={selectedModules.includes(child.key)}
                onToggle={onToggleModule}
                variant="child"
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default function ModulePermissionTree({
  pages = [],
  selectedModules = [],
  assignableKeys,
  onToggleModule,
}) {
  return (
    <div className="mu-invite__modules">
      {pages.map((page) => {
        const hasChildren = !!page.children?.length;

        if (!hasChildren) {
          return (
            <ModuleToggle
              key={page.key}
              mod={page}
              checked={selectedModules.includes(page.key)}
              onToggle={onToggleModule}
            />
          );
        }

        return (
          <ModuleGroup
            key={page.key}
            page={page}
            selectedModules={selectedModules}
            assignableKeys={assignableKeys}
            onToggleModule={onToggleModule}
          />
        );
      })}
    </div>
  );
}
